<template>
  <div :class="classModifiers">
    <div v-if="!isComponentReady" class="hero-unit-slider__loader"></div>
    <swiper v-else v-bind="swiperOptions" :modules="swiperModules">
      <swiper-slide
        v-for="banner in items"
        :key="banner.carouselId"
        class="hero-unit-slider__slide"
      >
        <div
          :style="bannerImageStyleModifiers(banner.carouselData.image)"
          class="hero-unit-slider__image"
        ></div>
        <div class="hero-unit-slider__content">
          <p
            class="hero-unit-slider__para"
            v-if="banner.carouselData.carouselItemHeader.secondLine"
            v-html="banner.carouselData.carouselItemHeader.secondLine"
          ></p>
          <h2
            class="hero-unit-slider__headline"
            v-if="banner.carouselData.carouselItemHeader.firstLine"
            v-html="banner.carouselData.carouselItemHeader.firstLine"
          ></h2>
          <template v-if="banner.carouselData.carouselItemButton">
            <a
              v-if="isUrlExternal(banner)"
              v-outer-link
              :href="getBannerUrl(banner)"
              v-html="banner.carouselData.carouselItemButton.text"
              :style="buttonStyleModifiers(banner.carouselData.carouselItemButton)"
              class="button button--medium button--submit hero-unit-slider__button"
            >
            </a>
            <router-link
              v-else
              :to="getBannerUrl(banner)"
              v-html="banner.carouselData.carouselItemButton.text"
              :style="buttonStyleModifiers(banner.carouselData.carouselItemButton)"
              class="button button--medium button--submit hero-unit-slider__button"
            >
            </router-link>
          </template>
        </div>
      </swiper-slide>
      <template v-slot:pagination>
        <div class="hero-unit-slider__pagination"></div>
      </template>
    </swiper>
  </div>
</template>

<script src="./hero-unit-slider.js"></script>
<style src="./hero-unit-slider.scss" lang="scss"></style>
